var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 12v-2M6.713 1.88l-4.62 3.7c-.52.413-.853 1.287-.74 1.94l.887 5.307c.16.946 1.067 1.713 2.027 1.713h7.466c.954 0 1.867-.773 2.027-1.713l.886-5.307c.107-.653-.226-1.527-.74-1.94l-4.62-3.693c-.713-.574-1.866-.574-2.573-.007"
  })));
};
export default SvgHome;